interface ComparisonSignalForgeBadgeProps {
  enabled?: boolean;
}

const BADGE_BASE =
  'inline-flex items-center gap-1 whitespace-nowrap rounded-[6px] border py-0.5 pl-1.5 pr-2 text-[10px] font-semibold leading-[1.2] tracking-[0.02em] cursor-default opacity-[0.72]';

const ComparisonSignalForgeBadge = ({
  enabled = false,
}: ComparisonSignalForgeBadgeProps) => {
  const toneClass = enabled
    ? 'bg-secondary/7 text-[color:rgba(255,193,120,0.62)] border-secondary/20 shadow-none'
    : 'bg-white/[0.025] text-white/[0.42] border-white/[0.08]';

  const iconClass = enabled
    ? 'shrink-0 opacity-65 text-[color:rgba(255,193,120,0.55)]'
    : 'shrink-0 opacity-85';

  const dotClass = enabled
    ? 'h-1.5 w-1.5 shrink-0 rounded-full bg-positive/35'
    : 'h-1.5 w-1.5 shrink-0 rounded-full bg-white/20';

  return (
    <span
      className={`${BADGE_BASE} ${toneClass}`}
      aria-label={enabled ? 'SignalForge on (read-only)' : 'SignalForge off (read-only)'}
    >
      <svg
        className={iconClass}
        width="12"
        height="12"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <path d="M4 18V14" />
        <path d="M8 18V10" />
        <path d="M12 18V12" />
        <path d="M16 18V6" />
      </svg>
      <span>{enabled ? 'SignalForge On' : 'SignalForge Off'}</span>
      <span className={dotClass} aria-hidden />
    </span>
  );
};

export default ComparisonSignalForgeBadge;
